<template>
    <div class="dropdown action-menu">
        <CellPopover
            ref="popover"
            :title="title"
            :label="label || title"
            :disabled="disabled"
            trigger-tag="button"
            :trigger-class="['action-menu__trigger', triggerClass]"
            :trigger-attrs="triggerAttrs"
            :min-width="minWidth"
            :max-width="maxWidth"
            :align="align"
            keep-mounted
            action-menu
        >
            <template #trigger>
                <slot name="trigger"><i class="fas fa-ellipsis-v" aria-hidden="true"></i></slot>
            </template>
            <template #default>
                <ul :class="['dropdown-menu show action-menu__items', menuClass]">
                    <slot :close="close" />
                </ul>
            </template>
        </CellPopover>
    </div>
</template>

<script setup>
import { ref } from "vue";
import CellPopover from "./CellPopover.vue";

defineProps({
    title: { type: String, default: "Actions" },
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    minWidth: { type: Number, default: 240 },
    maxWidth: { type: Number, default: 320 },
    align: { type: String, default: "end" },
    triggerClass: { type: [String, Array, Object], default: "card-overflow-trigger" },
    triggerAttrs: { type: Object, default: () => ({}) },
    menuClass: { type: [String, Array, Object], default: "" }
});
const popover = ref(null);
const close = () => popover.value?.close();
defineExpose({ close, focus: () => popover.value?.focus() });
</script>

<style>
.action-menu {
    display: inline-flex;
    flex: 0 0 auto;
}

.action-menu .action-menu__trigger {
    width: auto;
    min-width: 44px;
    min-height: 44px;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--forkto-ink-2);
    border-radius: var(--forkto-radius-compact);
}

.action-menu__items.dropdown-menu {
    position: static;
    float: none;
    width: 100%;
    min-width: 0;
    max-width: none;
    margin: 0;
    padding: 0;
    border: 0;
    box-shadow: none;
    background: transparent;
    --bs-dropdown-link-color: var(--forkto-ink-2);
    --bs-dropdown-link-hover-color: var(--forkto-ink-1);
    --bs-dropdown-link-hover-bg: var(--forkto-sunk);
    --bs-dropdown-link-active-color: var(--forkto-ink-1);
    --bs-dropdown-link-active-bg: var(--forkto-sunk);
}

.action-menu__items .dropdown-item {
    white-space: normal;
    overflow-wrap: anywhere;
    border-radius: var(--forkto-radius-compact);
}

/* Menu actions use words. Keep progress indicators visible while busy. */
.action-menu__items .dropdown-item > i {
    display: none;
}

.cell-popover__panel--sheet .action-menu__items .dropdown-item {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 0.65rem 0.75rem;
}

.cell-popover__panel--sheet .action-menu__items .dropdown-item-danger,
.cell-popover__panel--sheet .action-menu__items .text-danger {
    color: var(--forkto-fail) !important;
}
</style>
